import React from 'react';

import { Guard } from '../../utility/guard';
import { useGuard } from '../../hooks';

type Props = {
  guard: Guard;
  children?: React.ReactNode;
};

const Permission = ({
  guard,
  children,
}: Props) => {
  const isAllowed = useGuard(guard);

  return (
    <>
      {isAllowed ? children : null}
    </>
  );
};

export default Permission;
